import * as React from 'react';
import { PlanModel } from '@journeyapps-platform/lib-journey-core';
import { styled } from '../../../../../theme';
import { TableWidget } from '../../../../../widgets/table/TableWidget';
import * as _ from 'lodash';
import { DateTime } from 'luxon';

export interface PlanBreakdownWidgetProps {
  plan: PlanModel;
}

const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const qty = new Intl.NumberFormat('en-US', {});

export const PlanBreakdownWidget: React.FC<PlanBreakdownWidgetProps> = (props) => {
  let rows = _.chain(props.plan.model.entries)
    .groupBy((e) => {
      const start = DateTime.fromISO(e.start).toLocaleString();
      const end = DateTime.fromISO(e.end).toLocaleString();
      return `${start} to ${end}`;
    })
    .flatMap((entries, group) => {
      return [
        {
          key: group,
          cells: {
            label: group,
            qty: '',
            amount: '',
            date_row: true
          }
        },
        ...entries.map((e, index) => {
          return {
            key: `group-${index}`,
            cells: {
              label: e.label,
              qty: qty.format(e.qty),
              amount: formatter.format(e.amount / 100.0),
              date_row: false
            }
          };
        })
      ];
    })
    .value();

  return (
    <TableWidget
      rows={rows}
      columns={[
        {
          key: 'label',
          display: 'Item',
          accessor: ({ row, cell }) => {
            if (row.cells.date_row) {
              return <S.DateRow>{cell}</S.DateRow>;
            }
            return cell;
          }
        },
        {
          key: 'qty',
          display: 'Qty'
        },
        {
          key: 'amount',
          display: 'Total',
          right: true
        }
      ]}
    />
  );
};
namespace S {
  export const DateRow = styled.div`
    opacity: 0.5;
  `;
}
